module.exports = __webpack_public_path__ + "static/media/ax.1d5070cb.svg";